import {TextField} from 'formik-material-ui'
import React, {Fragment} from 'react'
import {Grid, Grow, Typography} from '@material-ui/core'
import {Field} from 'formik'
import MaskField from '../../../../components/MaskField'

import {StepHeader} from '../../styles'

const Step9 = () => {
  return (
    <Fragment>
      <Grow mountOnEnter in timeout={500}>
        <StepHeader>
          <Typography
            variant="body1"
            gutterBottom
            color="textPrimary">
            Passo 2 de 3
          </Typography>
          <Typography
            variant="h5"
            gutterBottom
            color="textPrimary">
            Dados do representante
          </Typography>
        </StepHeader>
      </Grow>
      <Grow mountOnEnter in timeout={900}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Field
              fullWidth
              color="primary"
              label="CPF do Representante"
              mask="999.999.999-99"
              name="partnerCpf"
              component={MaskField}
            />
          </Grid>
          <Grid item xs={12}>
            <Field
              fullWidth
              color="primary"
              label="Nome completo"
              name="partnerName"
              component={TextField}
            />
          </Grid>
          <Grid item xs={12}>
            <Field
              fullWidth
              color="primary"
              label="Nome da mãe"
              name="motherName"
              component={TextField}
            />
          </Grid>
        </Grid>
      </Grow>
    </Fragment>
  )
}

export default Step9
